import { userInfoStore } from '../../../store/userInfoStore';
import { doubleDiceBetsStore } from '../doubleDiceStore/betStore';
import { autoBetStore } from '../../../store/autoBetStore';
import { checkHashStore } from '../../../store/checkHashStore';
import { ValidationType } from '../../../core/constants/validationType';
import { notificationStore } from '../../../store/notificationStore';
import { soundService } from '../../../services/baseSoundService/soundService';
import { userSettingsStore } from '../../../store/userSettingsStore';
import { betHistoryStore } from '../../../store/betHistoryStore';
import { DICE_TYPES, DoubleDiceSoundsName } from '../doubleDiceCore/constants';
import { applicationStore } from '../../../store/applicationStore';
import { isPG } from '../../../core/helpers/skinHelper';
import { liveUpdateStore } from '../../../store/liveUpdateStore';
import { THIS_GAMES_COLUMN_ID } from '../../../core/constants/liveBetsContants';
import { mainGameConnection } from '../../../core/mainGameConnection/mainGameConnection';

let autoBetTimeOutId;
let resetGameDataTimeOutId;
let winAnimationId;

class DoubleDiceGameService {
  onGetInitialStateResult({ quickBets, lastSpinInfo, maxWinLimit }) {
    this.handleResetInitial();
    if (lastSpinInfo) {
      checkHashStore.setLastRoundInfo(lastSpinInfo);
      checkHashStore.setLastRoundResult(lastSpinInfo);
    }
    userInfoStore.setLimits({ minBet: quickBets[0], maxBet: quickBets[quickBets.length - 1] });
    doubleDiceBetsStore.setMaxWinLimit(maxWinLimit);
    applicationStore.setIsSocketConnected(true);
    applicationStore.setIsConnectionLost(false);
    if (isPG()) {
      userInfoStore.setMargin(3);
      liveUpdateStore.setSelectedColumn(THIS_GAMES_COLUMN_ID);
    } else {
      userInfoStore.setMargin(1);
    }
  }

  doSpin() {
    if (autoBetStore.isAutoBetOn && !autoBetStore.isAutoBetStart) {
      autoBetStore.setIsAutoBetStart(true);
    }
    if (doubleDiceBetsStore.isBetsClosed) {
      return;
    }
    const model = {
      spinData: {
        amount: userInfoStore.betAmount,
        leftSpinMarket: doubleDiceBetsStore.dicesValues[DICE_TYPES.First].rangeType,
        rightSpinMarket: doubleDiceBetsStore.dicesValues[DICE_TYPES.Second].rangeType,
        leftNumber: doubleDiceBetsStore.dicesValues[DICE_TYPES.First].rangeValue,
        rightNumber: doubleDiceBetsStore.dicesValues[DICE_TYPES.Second].rangeValue,
      },
      isAutoplay: autoBetStore.isAutoBetOn,
    };
    if (userSettingsStore.isSoundOn) {
      soundService.play(DoubleDiceSoundsName.bet);
    }
    clearTimeout(winAnimationId);
    doubleDiceBetsStore.setIsWin(null);
    doubleDiceBetsStore.setIsBetsClosed(true);
    doubleDiceBetsStore.setIsLastRoundWin(null);
    mainGameConnection.doSpin(model);
  }

  handleDoSpinResult({
    responseCode,
    totalWinAmount,
    leftWinAmount,
    rightWinAmount,
    hash,
    salt,
    key,
    newHash,
    id,
    odd,
    balance,
    result,
  }) {
    if (responseCode === ValidationType.Success) {
      const {
        rightNumber,
        leftNumber,
        rightSpinMarket,
        leftSpinMarket,
        leftOdd,
        rightOdd,
        leftResultNumber,
        rightResultNumber,
      } = result;
      userInfoStore.setUserBalance(balance);
      doubleDiceBetsStore.setIsAnimationEnd(true);
      doubleDiceBetsStore.setIsBothEnabled(true);
      setTimeout(
        () => {
          doubleDiceBetsStore.setIsAnimationEnd(false);
          doubleDiceBetsStore.setIsBothEnabled(false);
        },
        userSettingsStore.isTurboOn ? 400 : 1200
      );
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.setAutoBetCount(autoBetStore.autoBetCount - 1);
      }
      doubleDiceBetsStore.setIsWin(Boolean(totalWinAmount));
      winAnimationId = setTimeout(() => {
        userInfoStore.getBalance();
        doubleDiceBetsStore.setIsWin(null);
      }, 1500);
      doubleDiceBetsStore.setWinAmount(totalWinAmount);
      doubleDiceBetsStore.setWinOdd(odd);
      doubleDiceBetsStore.setIsLastRoundWin(Boolean(totalWinAmount));
      checkHashStore.setLastRoundInfo({ salt, key, hash });
      checkHashStore.setNextRoundHash(newHash);
      checkHashStore.setLastRoundResult({
        id,
        rightResultNumber,
        leftResultNumber,
        leftOdd,
        rightOdd,
        leftNumber,
        rightNumber,
        leftSpinMarket,
        rightSpinMarket,
      });
      if (userSettingsStore.isSoundOn) {
        if (userSettingsStore.isTurboOn) {
          if (totalWinAmount) {
            soundService.play(DoubleDiceSoundsName.win);
          }
        } else {
          soundService.play(DoubleDiceSoundsName.increase).then(() => {
            if (totalWinAmount) {
              setTimeout(() => {
                soundService.play(DoubleDiceSoundsName.win);
              }, 500);
            }
          });
        }
      }
      doubleDiceBetsStore.updateLastResults({
        rightResult: {
          resultNumber: rightResultNumber,
          isWin: Boolean(rightWinAmount),
        },
        leftResult: {
          resultNumber: leftResultNumber,
          isWin: Boolean(leftWinAmount),
        },
      });

      clearTimeout(resetGameDataTimeOutId);
      resetGameDataTimeOutId = setTimeout(() => {
        this.resetGameData();
      }, (userSettingsStore.isTurboOn ? 200 : 400) + (odd >= 10 ? 800 : 0));
      if (autoBetStore.isAutoBetStart && autoBetStore.autoBetCount) {
        autoBetTimeOutId = setTimeout(
          () => {
            this.doSpin();
          },
          userSettingsStore.isTurboOn ? 1000 : 2000
        );
      } else {
        this.resetAutoBetState();
      }
    } else {
      notificationStore.setNotification(responseCode);
      doubleDiceBetsStore.setIsBetsClosed(false);
      if (autoBetStore.isAutoBetStart) {
        autoBetStore.resetAutoBetState();
      }
    }
  }

  resetGameData() {
    betHistoryStore.getLastBet();
    doubleDiceBetsStore.setIsBetsClosed(false);
  }

  resetAutoBetState() {
    if (autoBetStore.isAutoBetStart && autoBetStore.isAutoBetOn && !autoBetStore.autoBetCount) {
      setTimeout(() => {
        autoBetStore.resetAutoBetState();
        this.clearAutoBetTimeOut();
      }, 1500);
    }
  }

  clearAutoBetTimeOut() {
    clearTimeout(autoBetTimeOutId);
  }

  handleResetInitial() {
    this.resetAutoBetState();
    this.resetGameData();
  }
}

export const doubleDiceGameService = new DoubleDiceGameService();
